module.exports = __webpack_public_path__ + "img/cover.9d91843d.png";